import { useEffect, useState } from 'react';

import { useListAllBezugspersonenQuery } from '../../../../../api/generated/bezugperson-controller/bezugperson-controller';

const DEFAULT_PAGE_SIZE = 20;
const SEARCH_DEBOUNCE_MS = 300;

export function useReferencePersonTable() {
  const [page, setPage] = useState(0);
  const size = DEFAULT_PAGE_SIZE;
  const [search, setSearch] = useState('');
  const [debouncedSearch, setDebouncedSearch] = useState('');

  useEffect(() => {
    const timeout = setTimeout(() => {
      setDebouncedSearch(search.trim());
    }, SEARCH_DEBOUNCE_MS);

    return () => clearTimeout(timeout);
  }, [search]);

  const { data, isLoading, isFetching } = useListAllBezugspersonenQuery({
    page,
    size,
    search: debouncedSearch || undefined,
  });

  const items = data?.content ?? [];
  const totalCount = data?.totalCount ?? 0;
  const currentPage = data?.page ?? page;
  const currentSize = data?.size ?? size;
  const totalPages = currentSize > 0 ? Math.ceil(totalCount / currentSize) : 0;

  const handleSearchChange = (value: string) => {
    setSearch(value);
    setPage(0);
  };

  return {
    items,
    isLoading: isLoading || isFetching,
    page: currentPage,
    totalPages,
    search,
    setSearch: handleSearchChange,
    setPage,
  };
}
